import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  CLASSES_FILTER_REQUEST,
  CLASSES_FILTER_SUCCESS,
  CLASSES_FILTER_FAILURE,
  CLASSES_FILTER_CLEAR,
  CLASSES_FILTER_DELETE,
  CLASSES_FILTER_SET,
  CLASSES_FILTER_UPDATE,
} from 'app/actions/reports/filters/classes';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  active: false,
};

const classes = (state = defaultState, { type, payload }) => {
  switch (type) {
    case CLASSES_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case CLASSES_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case CLASSES_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case CLASSES_FILTER_CLEAR: {
      return defaultState;
    }
    case CLASSES_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case CLASSES_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case CLASSES_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default classes;
